import * as T from '@/types'

////////////////////////////////////////////////////////////////
// interfaces
////////////////////////////////////////////////////////////////

export interface OperatorDefinition {
    type: T.OperatorType
    name: string
    symbol: string
}

////////////////////////////////////////////////////////////////
// enums
////////////////////////////////////////////////////////////////

export enum OperatorType {
    LESS_THAN = 'OPERATOR.LESS_THAN',
    LESS_THAN_OR_EQUAL_TO = 'OPERATOR.LESS_THAN_OR_EQUAL_TO',
    EQUAL_TO = 'OPERATOR.EQUAL_TO',
    GREATER_THAN_OR_EQUAL_TO = 'OPERATOR.GREATER_THAN_OR_EQUAL_TO',
    GREATER_THAN = 'OPERATOR.GREATER_THAN',
}
